function balancel3Menus() {
    //L2 and L3 initial submenu items on L1 hover 
    $(`#navbar-nav > ul.navbar-nav li.nav-item a.nav-link`).hover(e => {
        $closestChildElement = $(e.target).next()[0];
        ($closestChildElement) && ($closestChildElement.hasAttribute('id') && ($currNavHover = $(e.target).next()[0].id));
        $currentActiveItem = $('#navbar-nav').find('[data-pane="' + $currNavHover + '"]').find('.active');
        $noOfItemsInInitialL3 = $currentActiveItem.find('li').length;
        $ulOfInitialL3 = $currentActiveItem.find("ul");
        setMaxHeight($noOfItemsInInitialL3, $ulOfInitialL3);
    });
    //L3 menu items on L2 hover 
    $("#navbar-nav .main-top-menu__item .site-header__submenu-action").on("show.bs.tab", e => {
        const currentHover = $(e.target).data("default");
        $targettedPane = $("#" + currentHover);
        const countOfItems = $targettedPane.find("ul li").length;
        const subItemsOfCurrentHover = $targettedPane.find("ul");
        setMaxHeight(countOfItems, subItemsOfCurrentHover);
    })
}

document.addEventListener('dynamicMenuLoaded', balancel3Menus);

const setMaxHeight = (noOfliElements, ulElement) => {
    const liHeight = 38;
    (noOfliElements === 7) ? ulElement.css("max-height", '17rem') : (noOfliElements > 7) && ulElement.css("max-height", (Math.round(noOfliElements / 2) * liHeight));
};